// extracted by mini-css-extract-plugin
module.exports = {"footer":"FileParser_footer__g2b7J"};